module.exports = __webpack_public_path__ + "static/media/aboutMePic.e8176c74.jpg";